import type { Directive } from 'vue';

import { isTestingEnv } from '@modules/core/services/env-config/utils/envConfig';
import { toKebabCase } from '@utils/string';

export interface DataTestAttributes {
  el: string;
  [key: string]: string;
}

function createTestAttribute(attributes?: DataTestAttributes): Record<string, string> {
  if (!attributes?.el) {
    return {};
  }

  return Object.keys(attributes).reduce((result, key) => {
    const name = key === 'el' ? 'data-test-el' : `data-test-attr-${toKebabCase(key)}`;

    result[name] = attributes[key];

    return result;
  }, {} as Record<string, string>);
}

export function setElementAttributes(element: Element, values: DataTestAttributes): void {
  if (!isTestingEnv()) {
    return;
  }

  const attributes = createTestAttribute(values);
  for (const key of Object.keys(attributes)) {
    try {
      element.setAttribute(key, attributes[key]);
    } catch {}
  }
}

export const vDataTest: Directive<Element, DataTestAttributes> = {
  beforeMount: (element, binding) => setElementAttributes(element, binding.value),
  updated: (element, binding) => setElementAttributes(element, binding.value),
  beforeUnmount: (element, binding) => setElementAttributes(element, binding.value),
};
